(function (root, factory) {
  var api = factory(root);

  root.PjDesignLabReposition = api;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  // Drag-to-reposition for the active pet on the Design Lab preview. Moving
  // only: the pet's size is system-controlled and can't be changed by the
  // customer. The offset is kept in the controls store (updatePetPosition) as a
  // percentage of the composite frame, so it survives zoom and re-renders.
  function createRepositionController(doc, options) {
    var config = options || {};
    var drag = null; // { index, frameRect, startX, startY, startOffsetX, startOffsetY }

    function controls() {
      return config.controls || root.PjDesignLabControls;
    }

    function snapshot() {
      var api = controls();
      return api && typeof api.snapshot === 'function' ? api.snapshot() : null;
    }

    function modalEl() {
      return doc.getElementById('pvModal');
    }

    function compositeFrame() {
      var loaded = modalEl() && modalEl().querySelector('[data-pv-region="loaded"]');
      return loaded && loaded.querySelector('.pv-composite');
    }

    // Marketing's shop-wide switch (shop metafield cuddleclones.pj_design_lab_manual_placement): off,
    // the pets stay where the system puts them.
    function manualPlacement() {
      var modal = modalEl();
      return Boolean(modal && modal.dataset && modal.dataset.manualPlacement === 'true');
    }

    // Event-delegated on the canvas region, so it survives the composite being
    // torn down and rebuilt on every render.
    function onPointerDown(event) {
      if (!manualPlacement()) return;
      var image = event.target.closest && event.target.closest('.pv-composite-pet');
      if (!image) return;

      var state = snapshot();
      if (!state) return;
      var index = Number(image.dataset.petIndex);
      if (index !== state.activePetIdx) return;

      var pet = state.pets[index];
      var frame = compositeFrame();
      if (!pet || !frame) return;
      var adjustment = pet.adjustment || { offsetX: 0, offsetY: 0 };

      drag = {
        index: index,
        frameRect: frame.getBoundingClientRect(),
        startX: event.clientX,
        startY: event.clientY,
        startOffsetX: adjustment.offsetX || 0,
        startOffsetY: adjustment.offsetY || 0,
      };

      if (typeof image.setPointerCapture === 'function' && event.pointerId != null) {
        // Best-effort: keeps the drag tracking past the image's edge. Some
        // browsers throw for a pointer id they don't consider active.
        try {
          image.setPointerCapture(event.pointerId);
        } catch (error) {
          // ignored
        }
      }
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!drag) return;
      var api = controls();
      var rect = drag.frameRect;
      if (!api || typeof api.updatePetPosition !== 'function' || !rect || !rect.width || !rect.height) {
        return;
      }
      api.updatePetPosition(drag.index, {
        offsetX: drag.startOffsetX + ((event.clientX - drag.startX) / rect.width) * 100,
        offsetY: drag.startOffsetY + ((event.clientY - drag.startY) / rect.height) * 100,
      });
    }

    function onPointerUp() {
      drag = null;
    }

    function init() {
      if (!doc) return;
      var modal = modalEl();
      var canvasRegion = modal && modal.querySelector('[data-pv-region="canvas"]');
      if (!canvasRegion) return;

      canvasRegion.addEventListener('pointerdown', onPointerDown);
      canvasRegion.addEventListener('pointermove', onPointerMove);
      canvasRegion.addEventListener('pointerup', onPointerUp);
      canvasRegion.addEventListener('pointercancel', onPointerUp);
    }

    return {
      init: init,
      onPointerDown: onPointerDown,
      onPointerMove: onPointerMove,
      onPointerUp: onPointerUp,
    };
  }

  var controller = root.document ? createRepositionController(root.document) : null;

  if (controller) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', controller.init, { once: true });
    } else {
      controller.init();
    }
  }

  return {
    createRepositionController: createRepositionController,
    init: controller && controller.init,
  };
});
